import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type { Error } from '@eggplant/types'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: string[]) => void
  children?: (response: string[]) => ReactElement
  shortErrorMessage?: string
  dataCenter: string
  platform: string
  browser: string
}

const GetSauceLabsVersions = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  dataCenter,
  platform,
  browser
}: Props) => {
  const url = `${SUT_SERVICE}/sauce_labs/data_centers/${dataCenter}/browser_platforms/${platform}/browsers/${browser}/versions`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetSauceLabsVersions
